import { pipe } from "ramda";
import { ajax } from "./mostAjax";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const getLicenseTypeUrl = () => `${API_BASE_URL}/vocabularies/license-types`;

export const fetchLicenseTypes = pipe(getLicenseTypeUrl, ajax);
